var _rect, _path, _path2, _path3, _path4, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisualStudioDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#242938"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_217_156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 28,
    width: 200,
    height: 200
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.6656 197.166L31.3344 172.166C30.2952 171.394 29.4519 170.389 28.8727 169.23C28.2935 168.072 27.9946 166.795 28.0001 165.5V90.5001C27.9946 89.2054 28.2935 87.9276 28.8727 86.7698C29.4519 85.6119 30.2952 84.6065 31.3344 83.8345L64.6656 58.8345C63.7702 59.6752 63.0936 60.7218 62.6944 61.8835C62.2952 63.0451 62.1856 64.2866 62.375 65.5001V190.5C62.1856 191.714 62.2952 192.955 62.6944 194.117C63.0936 195.278 63.7702 196.325 64.6656 197.166Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M224.29 62.7093C222.917 61.8073 221.308 61.3291 219.665 61.3344C218.601 61.3258 217.544 61.5273 216.558 61.9274C215.571 62.3274 214.673 62.9181 213.915 63.6656L213.334 64.25L146.834 128L110.04 163.291L75.9999 195.915L75.4156 196.5C74.6583 197.248 73.7604 197.84 72.7736 198.241C71.7868 198.641 70.7305 198.843 69.6656 198.834C67.8628 198.83 66.1092 198.246 64.6656 197.165L31.3344 172.166C33.0279 173.437 35.1424 174.016 37.2476 173.784C39.3528 173.552 41.2902 172.526 42.6656 170.915L79.6656 127.959L110.04 92.7093L163.25 30.9156C164.022 30.0005 164.985 29.2654 166.072 28.7617C167.159 28.2581 168.343 27.9981 169.541 28C171.184 27.9947 172.792 28.4729 174.165 29.375L224.29 62.7093Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M224.29 193.29L174.291 226.624C172.589 227.735 170.545 228.195 168.532 227.92C166.52 227.644 164.674 226.651 163.334 225.125L110.04 163.291L79.6656 127.959L42.6656 85.0405C41.278 83.4462 39.3387 82.4358 37.2369 82.2121C35.1352 81.9883 33.0266 82.5679 31.3344 83.8344L64.6656 58.8344C66.1092 57.7545 67.8628 57.1692 69.6656 57.1656C70.7305 57.1566 71.7868 57.3582 72.7736 57.7588C73.7604 58.1595 74.6583 58.7512 75.4156 59.5L75.9999 60.0843L110.04 92.7094L146.834 128L213.334 191.75L213.915 192.334C214.673 193.082 215.571 193.672 216.558 194.072C217.544 194.472 218.601 194.674 219.665 194.665C221.308 194.671 222.917 194.193 224.29 193.29Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M228 69.6655V186.334C228.001 187.709 227.663 189.064 227.016 190.276C226.369 191.49 225.433 192.525 224.29 193.29L174.291 226.624C175.433 225.859 176.369 224.823 177.017 223.609C177.663 222.395 178 221.041 177.999 219.665V36.3343C177.981 34.9486 177.622 33.5889 176.953 32.3751C176.284 31.1613 175.327 30.1309 174.165 29.375L224.29 62.7093C225.429 63.4774 226.364 64.5131 227.011 65.7258C227.658 66.9385 227.997 68.2911 228 69.6655Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_217_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.6656 197.165L31.3344 172.166C30.2952 171.394 29.4519 170.387 28.8727 169.23C28.2935 168.072 27.9946 166.794 28.0001 165.5V90.4999C27.9946 89.2052 28.2935 87.9273 28.8727 86.7696C29.4519 85.6117 30.2952 84.6062 31.3344 83.8342L64.6656 58.8342C63.7702 59.675 63.0936 60.7216 62.6944 61.8832C62.2952 63.0449 62.1856 64.2863 62.375 65.4999V190.5C62.1856 191.714 62.2952 192.955 62.6944 194.117C63.0936 195.278 63.7702 196.324 64.6656 197.165Z",
    fill: "#5E438F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_217_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.289 62.7093C222.917 61.8073 221.308 61.3291 219.665 61.3344C218.601 61.3258 217.544 61.5273 216.557 61.9274C215.571 62.3274 214.673 62.9181 213.915 63.6656L213.334 64.25L177.914 98.2093L146.834 128L110.04 163.291L75.9993 195.915L75.4151 196.5C74.6577 197.248 73.7598 197.84 72.7731 198.241C71.7862 198.641 70.73 198.843 69.665 198.834C67.8622 198.83 66.1087 198.246 64.665 197.165L31.3338 172.166C33.0272 173.437 35.1418 174.016 37.247 173.784C39.3522 173.552 41.2897 172.526 42.6651 170.915L61.3338 149.25L79.665 127.959L110.04 92.7093L163.249 30.9156C164.022 30.0005 164.985 29.2654 166.072 28.7617C167.158 28.2581 168.343 27.9981 169.539 28C171.183 27.9947 172.791 28.4729 174.165 29.375L224.289 62.7093Z",
    fill: "url(#paint0_linear_217_156)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_217_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.289 193.29L174.29 226.625C172.589 227.736 170.545 228.195 168.532 227.92C166.519 227.644 164.674 226.652 163.334 225.125L110.04 163.291L79.665 127.959L61.3338 106.709L42.6651 85.0407C41.2774 83.4464 39.338 82.436 37.2363 82.2122C35.1347 81.9884 33.026 82.5681 31.3338 83.8344L64.665 58.8345C66.1087 57.7546 67.8622 57.1693 69.665 57.1658C70.73 57.1568 71.7862 57.3584 72.7731 57.759C73.7598 58.1596 74.6577 58.7514 75.4151 59.5002L75.9993 60.0845L110.04 92.7094L146.834 128L177.958 157.835L213.334 191.75L213.915 192.335C214.673 193.082 215.571 193.672 216.557 194.072C217.544 194.472 218.601 194.674 219.665 194.665C221.308 194.671 222.917 194.192 224.289 193.29Z",
    fill: "url(#paint1_linear_217_156)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_217_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228 69.6653V186.333C228.001 187.709 227.663 189.063 227.016 190.277C226.369 191.489 225.433 192.525 224.29 193.29L174.29 226.624C175.433 225.859 176.369 224.823 177.015 223.609C177.663 222.395 178 221.041 177.999 219.665V36.3341C177.981 34.9485 177.622 33.5886 176.953 32.3748C176.284 31.161 175.327 30.1307 174.165 29.3748L224.29 62.709C225.429 63.4771 226.363 64.5129 227.011 65.7256C227.657 66.9383 227.997 68.291 228 69.6653Z",
    fill: "url(#paint2_linear_217_156)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_217_156",
    x: 26.1529,
    y: 24.1143,
    width: 203.317,
    height: 181.196,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.246095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.246095
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_217_156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.29524
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.59048
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_217_156",
    result: "effect2_dropShadow_217_156"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_217_156",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_217_156",
    x: 26.1529,
    y: 53.2798,
    width: 203.317,
    height: 181.194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.246095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.246095
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_217_156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.29524
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.59048
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_217_156",
    result: "effect2_dropShadow_217_156"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_217_156",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_217_156",
    x: 158.622,
    y: 13.8319,
    width: 84.9208,
    height: 228.335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.129524
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_217_156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.77143
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_217_156",
    result: "effect2_dropShadow_217_156"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_217_156",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_217_156",
    x1: 190.499,
    y1: 28,
    x2: 41.9893,
    y2: 177.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7252AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7252AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_217_156",
    x1: 46.7501,
    y1: 64.4571,
    x2: 186.332,
    y2: 220.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE7FE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A70D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_217_156",
    x1: 200.49,
    y1: 25.3528,
    x2: 200.49,
    y2: 226.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D59DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C18EF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualStudioDark);
export default __webpack_public_path__ + "static/media/VisualStudio-Dark.22775867ab4c1b8f78a79c0a3730a85c.svg";
export { ForwardRef as ReactComponent };